import React from 'react'
import Cara from "../images/cara.png";
export default function CaraAiTitle(props) {
  return (
    <>
      <div style={{ 
          display: "flex", 
          alignItems: "center", 
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", 
          borderRadius: "999px", 
          border: "1px solid #ddd", 
          marginRight: "auto", 
          paddingRight: "12px", 
          fontSize: "13px", 
          color: "#8a8a8a" 
      }}>
          <img src={Cara} alt="my-img" style={{ marginRight: "6px" }} />
          {props.title}
      </div>

    </>
  )
}
